export default "__VITE_ASSET__FAKZp18e__"